module.exports = __webpack_public_path__ + "static/media/img_8.1ac74b86.jpg";